import { IS_KLAP_ENABLED, KLAP, KLAP_SDK_URL } from '../constants/payment'

let klapSdkPromise = null

export const loadKlapSdk = () => {
  if (!IS_KLAP_ENABLED) return Promise.resolve(false)
  if (klapSdkPromise) return klapSdkPromise

  klapSdkPromise = new Promise((resolve) => {
    const script = document.createElement('script')
    script.src = KLAP_SDK_URL
    script.type = 'text/javascript'
    script.onload = () => resolve(true)
    script.onerror = () => {
      klapSdkPromise = null
      resolve(false)
    }
    document.head.appendChild(script)
  })
  return klapSdkPromise
}

export const removeDisabledKlap = (ownPayments) => {
  if (IS_KLAP_ENABLED || !ownPayments || typeof ownPayments !== 'object') return ownPayments
  return Object.fromEntries(
    Object.entries(ownPayments).filter(([, gateway]) => gateway !== KLAP)
  )
}
